import "./Counters.css";
import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";

const COLOR_BY_TITLE = {
  Maestras: "bg-maestras",
  "M. Externas": "bg-externas",
  Alumnas: "bg-alumnas",
  Especial: "bg-especial",
  Cursos: "bg-cursos",
  Actividades: "bg-actividades",
  Comentarios: "bg-comentarios",
  Solicitudes: "bg-solicitudes",
};


function Stats() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_BASE_API}api/counters/`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setStatistics(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setLoading(false);
      });
  }, []);

  // Ensure exactly 9 items, adding empty placeholders if needed
  const filledStatistics = [
    ...statistics,
    ...Array(Math.max(0, 9 - statistics.length)).fill(null),
  ];

  return (
    <div id="counters">
      {loading
        ? Array(9)
            .fill(null)
            .map(
              (
                _,
                index, // Show placeholders while loading
              ) => (
                <div key={`placeholder-${index}`} className="counters-square">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <Spinner animation="border" role="status" />
                  </div>
                </div>
              ),
            )
        : filledStatistics.map((stat, index) =>
            stat ? (
              <OverlayTrigger
                key={index}
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>{stat.description}</Tooltip>
                }
              >
                <a
                  className={`counters-square ${
                    COLOR_BY_TITLE[stat.title] || "bg-default"
                  }`}
                  href={stat.url}
                >
                  <div className="counters-content">
                    <CountUp
                      end={stat.count}
                      duration={1.5}
                      className="counters-intra"
                    />
                    <h1 className="counters-title">{stat.title}</h1>
                  </div>
                </a>
              </OverlayTrigger>
            ) : (
              <div
                key={`empty-${index}`}
                className="counters-square"
                style={{ background: "pink" }}
              >
                <strong>?</strong>
              </div>
            ),
          )}
    </div>
  );
}

export default Stats;
